import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { Contacts } from './types';

export function useContactsData(): Page<Contacts>['templateFields'] {
  return useCurrentPage<Page<Contacts>>().templateFields;
}
